/* Stock-on-hand bridge. One file, shared across stores.
   FEED_ORIGIN is the only per-store setting. */
(function () {
  "use strict";

  var FEED_ORIGIN = "https://megaofficesupplies.com.au";
  var STOCK_JS = "/cdn/shop/files/pdp-stock.js";
  var SKU_SELECTORS = [".product__sku", ".product__sku-wrapper"];
  var SLOT_ID = "mos-soh-slot";

  /* 1. Feed bridge. pdp-stock.js requests root-relative /cdn/shop/files/itf-*.
     Those files do not exist on this store, so point them at the shared feed.
     Shopify's CDN sends Access-Control-Allow-Origin: * and the script already
     fetches with credentials:"omit", so this is a clean cross-origin read.
     Only itf-* paths are rewritten; every other request passes through. */
  if (!window.__sohFeedBridge) {
    window.__sohFeedBridge = 1;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === "string") ? input : (input && input.url);
        if (url && url.indexOf("/cdn/shop/files/itf-") === 0) {
          var rewritten = FEED_ORIGIN + url;
          input = (typeof input === "string") ? rewritten : new Request(rewritten, input);
        }
      } catch (e) {}
      return nativeFetch.call(this, input, init);
    };
  }

  /* 2. Variant awareness. pdp-stock.js reads the SKU from the DOM once and has
     no variant listener, so on a multi-variant product it would keep showing
     the first variant's stock. The theme does rewrite the SKU element, so watch
     it and re-run the script. pdp-stock.js ends with
     readyState === "loading" ? DOMContentLoaded : run(), so re-injecting it
     after load re-renders immediately.
     NOTE: .product__sku-title holds only the label "SKU:" -- the value lives in
     the parent as "SKU: SDSD43610", hence the strip below. */
  function currentSku() {
    for (var i = 0; i < SKU_SELECTORS.length; i++) {
      var el = document.querySelector(SKU_SELECTORS[i]);
      if (!el) continue;
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      t = t.replace(/^SKU\s*:\s*/i, "").trim();
      if (t) return t;
    }
    return "";
  }

  function watchVariant() {
    if (window.__sohVariantWatch) return;
    if (!document.getElementById(SLOT_ID)) return;
    window.__sohVariantWatch = 1;

    var last = currentSku();
    var timer = null;

    new MutationObserver(function () {
      var now = currentSku();
      if (!now || now === last) return;
      last = now;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var slot = document.getElementById(SLOT_ID);
        if (slot) slot.innerHTML = "";
        var s = document.createElement("script");
        s.src = STOCK_JS + "?rerun=" + Date.now();
        s.async = false;
        document.body.appendChild(s);
        setTimeout(function () { try { s.remove(); } catch (e) {} }, 8000);
      }, 150);
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchVariant);
  } else {
    watchVariant();
  }
})();